import styles from './RecommendedJobsDashboard.less';

import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import { jobDetailUrlPrefix } from 'config';
import { ThumbsUpIcon, ChevronIcon } from 'seek-style-guide/react';
import ExternalLink from 'ExternalLink/ExternalLink';
import DashboardItem from 'DashboardItem/DashboardItem';
import DashboardHeading from 'DashboardHeading/DashboardHeading';
import { ScreenReaderOnly } from 'seek-style-guide/react';

@connect(({ dashboard }) => ({
  recommendedJobs: dashboard.recommendedJobs.data,
  totalCount: dashboard.recommendedJobs.totalCount
}))
export default class RecommendedJobsDashboard extends Component {

  static propTypes = {
    recommendedJobs: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        title: PropTypes.string.isRequired,
        advertiser: PropTypes.string.isRequired,
        daysAgo: PropTypes.string.isRequired,
        isNew: PropTypes.bool.isRequired
      })
    ),
    totalCount: PropTypes.number
  };

  static defaultProps = {
    recommendedJobs: [],
    totalCount: 0
  };

  renderJobItem(job) {
    const {
      id,
      title,
      advertiser,
      isNew
    } = job;
    /* eslint-disable react/jsx-no-bind */
    return (
      <DashboardItem
        key={id}
        heading={() => (
          <span>
            { isNew && (
              <span data-automation="dashboardRecommendedJobsNew" className={styles.isNew}>
                New<ScreenReaderOnly>recommendation</ScreenReaderOnly>
                <span>{' — '}</span>
              </span>
            )}
            <ExternalLink
              className={styles.link}
              analytics="dashboard-recommended-job-click"
              data-automation="recommendedJobHeadingLink"
              href={`${jobDetailUrlPrefix}${id}?ref=recom`}>
              {title}
              <ScreenReaderOnly>. At {advertiser}</ScreenReaderOnly>
            </ExternalLink>
          </span>
        )}
        subheading={() => (
          <span aria-hidden="true" data-automation="recommendedJobAdvertiser">
            {advertiser}
          </span>
        )}
      />
    );
    /* eslint-enable react/jsx-no-bind */
  }

  render() {
    const { recommendedJobs, totalCount } = this.props;
    const label = `Recommended ${totalCount === 1 ? 'job' : 'jobs'}`;

    return (
      <nav role="navigation" data-automation="recommendedJobsDashboard">
        <DashboardHeading
          label={label}
          count={totalCount}
          Icon={ThumbsUpIcon}
          iconClass={styles.icon}
          className={styles.heading}
          href="/recommended"
          analytics="dashboard-heading-recommended-jobs-click"
        />
        {
          recommendedJobs.length > 0 &&
            <div className={styles.items}>
              { recommendedJobs.map(this.renderJobItem) }
            </div>
        }
        {
          recommendedJobs.length > 0 &&
            <ExternalLink
              className={styles.viewAll}
              analytics="dashboard-all-recommended-jobs-click"
              data-automation="recommendedJobsViewAll"
              href="/recommended">
              View all<ScreenReaderOnly>recommended jobs</ScreenReaderOnly>
              <ChevronIcon
                className={styles.chevron}
                direction="right"
                svgClassName={styles.chevronSvg}
              />
            </ExternalLink>
        }
        {
          recommendedJobs.length === 0 &&
            <p className={styles.noItems}>
              {'Complete '}
              <ExternalLink
                analytics="dashboard-recommended-jobs-profile"
                className={styles.link}
                href="/profile/">
                your profile
              </ExternalLink>
              {' to see personalised job recommendations here.'}
            </p>
        }
      </nav>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./app/components/HomePage/components/Dashboard/components/SignedInDashboard/components/RecommendedJobsDashboard/RecommendedJobsDashboard.js
 **/